import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';

const MemberForm = ({ user }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    // Application Type
    applicationType: '', // 'new' or 'renewal'
    
    // Membership Plan
    membershipPlan: '',
    memberCardFee: false,
    
    // Section 1: Personal Details
    fullNames: '',
    otherNames: '',
    dateOfBirth: '',
    identityDocumentNumber: '',
    gender: '',
    nationality: '',
    currentMaritalStatus: '',
    fullNamesSpouse: '',
    previousMaritalStatus: [],
    fullNamesPreviousSpouse: '',
    personalIdFile: null,
    spouseIdFile: null,
    
    // Section 2: Contacts & Residence
    contactNumbersCallsMain: '',
    contactNumbersCallsOther: '',
    contactNumbersWhatsappMain: '',
    contactNumbersWhatsappOther: '',
    personalEmailAddress: '',
    homeLocationVillage: '',
    streetFullDescription: '',
    nameHomeownerChief: '',
    socialMediaChannelNames: '',
    utilityBillFile: null,
    
    // Section 3: Next of Kin Details
    nextKinTitleFullNames: '',
    nextKinRelationship: '',
    nextKinHomeLocationVillage: '',
    nextKinContactCalls: '',
    nextKinContactText: '',
    nextKinEmailAddress: '',
    nextKinIdFile: null,
    
    // Section 4: Career & Employment
    currentEmployerName: '',
    currentStartDateEndDate: '',
    currentDepartment: '',
    currentPosition: '',
    currentEmploymentNumber: '',
    currentContactMain: '',
    currentPlaceLocation: '',
    currentIndustrySector: '',
    highestQualification: '',
    immediatePastEmployerName: '',
    immediatePastStartDateEndDate: '',
    immediatePastDepartment: '',
    immediatePastPosition: '',
    immediatePastEmploymentNumber: '',
    immediatePastContactMain: '',
    immediatePastPlaceLocation: '',
    immediatePastIndustrySector: '',
    
    // Section 7: Funeral Cover & Benefits
    children: Array(6).fill({ name: '', gender: '', dob: '', issueCard: '' }),
    childrenPersonalities: [],
    addParentsInLawsExtended: [],
    parentsInLaws: Array(4).fill({ name: '', gender: '', dob: '', coverType: '' }),
    parentsInterests: [],
    extendedFamily: Array(6).fill({ name: '', gender: '', dob: '', coverType: '' }),
    externalFamilyMotivations: [],
    birthCertificates: [],
    parentsIds: [],
    extendedIds: [],
    
    // Section 8: Beneficiary Details
    beneficiaryTitleFullNames: '',
    beneficiaryIdNumber: '',
    beneficiaryNationality: '',
    beneficiaryRelationship: '',
    beneficiaryHomeLocationVillage: '',
    beneficiaryContactCalls: '',
    beneficiaryContactText: '',
    beneficiaryEmailAddress: '',
    beneficiaryIdFile: null,
    
    // Section 9: Member Application Declaration
    memberTitleFullNames: '',
    memberDate: '',
    fmlcRepTitleFullNames: '',
    fmlcRepPosition: 'FMLC Members Coordinator',
    fmlcRepDate: '',
    fmlcRepRemarks: '',
    fmlcRepSignature: '',
    fmlcApprTitleFullNames: '',
    fmlcApprPosition: 'FMLC Coordinator',
    fmlcApprDate: '',
    fmlcApprRemarks: '',
    fmlcApprSignature: '',
    otherComments: '',
    
    // Membership Fee & Payment Details
    mainSubscriptionFeeQty: 1,
    membershipCardQty: 0,
    additionalMembershipQty: 0,
    funeralMainSpouseQty: 1,
    funeralChildrenQty: 0,
    funeralParent1Qty: 0,
    funeralParent2Qty: 0,
    funeralInLaw1Qty: 0,
    funeralInLaw2Qty: 0,
    funeralExtended55Qty: 0,
    funeralExtended90Qty: 0,
    funeralExtended110Qty: 0,
    subscriptionFrequency: '', // 'monthly' or 'annual'
    agreeToPay: false,
    paymentMethod: '',
    mpesaNumber: '',
    ecocashNumber: '',
    accountHolder: '',
    bankName: '',
    accountNo: '',
    branchCode: '',
    paymentProof: null,
    
    // Declaration
    agreeToTerms: false,
    declarationSignature: '',
    declarationDate: '',
    
    // Query
    coordinatorQuery: ''
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showQuery, setShowQuery] = useState(false);

  useEffect(() => {
    const loadFormData = async () => {
      const docRef = doc(db, 'memberApplications', user.uid);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setFormData(docSnap.data());
      }
    };
    
    loadFormData();
  }, [user.uid]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === 'checkbox') {
      if (value) {
        // Multi-select checkbox (array)
        setFormData(prev => ({
          ...prev,
          [name]: checked
            ? [...(Array.isArray(prev[name]) ? prev[name] : []), value]
            : (Array.isArray(prev[name]) ? prev[name] : []).filter(item => item !== value)
        }));
      } else {
        // Boolean checkbox
        setFormData(prev => ({
          ...prev,
          [name]: checked
        }));
      }
    } else if (type === 'file') {
      alert('You will be contacted to provide the required attachments.');
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleArrayChange = (name, index, field, val) => {
    setFormData(prev => {
      const newArray = [...prev[name]];
      if (!newArray[index]) newArray[index] = {};
      newArray[index][field] = val;
      return { ...prev, [name]: newArray };
    });
  };

  const saveFormData = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, 'memberApplications', user.uid), formData);
    } catch (error) {
      console.error('Error saving form data:', error);
    }
    setSaving(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Save form data without file URLs since attachments are not allowed
      const formDataWithUrls = {
        ...formData,
        personalIdUrl: '',
        spouseIdUrl: '',
        utilityBillUrl: '',
        nextKinIdUrl: '',
        beneficiaryIdUrl: '',
        paymentProofUrl: '',
        birthCertificatesUrls: [],
        parentsIdsUrls: [],
        extendedIdsUrls: [],
        status: 'submitted',
        submittedAt: new Date()
      };
      
      await setDoc(doc(db, 'memberApplications', user.uid), formDataWithUrls);
      
      alert('Application submitted successfully! You will be contacted to provide the required attachments.');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your application. Please try again.');
    }
    
    setLoading(false);
  };

  const nextStep = () => {
    saveFormData();
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const showQueryMessage = () => {
    setShowQuery(true);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="form-section">
            <h3>Application Type</h3>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="applicationType"
                  value="new"
                  checked={formData.applicationType === 'new'}
                  onChange={handleChange}
                />
                NEW MEMBERSHIP APPLICATION FORM
              </label>
              <label>
                <input
                  type="radio"
                  name="applicationType"
                  value="renewal"
                  checked={formData.applicationType === 'renewal'}
                  onChange={handleChange}
                />
                RENEWAL
              </label>
            </div>
            
            <h3>Membership Plan</h3>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="membershipPlan"
                  value="Standard"
                  checked={formData.membershipPlan === 'Standard'}
                  onChange={handleChange}
                />
                Standard M 100.00
              </label>
              <label>
                <input
                  type="radio"
                  name="membershipPlan"
                  value="Silver"
                  checked={formData.membershipPlan === 'Silver'}
                  onChange={handleChange}
                />
                Silver M 160.00
              </label>
              <label>
                <input
                  type="radio"
                  name="membershipPlan"
                  value="Gold"
                  checked={formData.membershipPlan === 'Gold'}
                  onChange={handleChange}
                />
                Gold M 190.00
              </label>
              <label>
                <input
                  type="radio"
                  name="membershipPlan"
                  value="Platinum"
                  checked={formData.membershipPlan === 'Platinum'}
                  onChange={handleChange}
                />
                Platinum M 220.00
              </label>
            </div>
            <label>
              <input
                type="checkbox"
                name="memberCardFee"
                checked={formData.memberCardFee}
                onChange={handleChange}
              />
              Member Card Fee M 100.00
            </label>
            
            <h3>Section 1: Personal Details</h3>
            <div className="form-group">
              <label>1. Full Names (as Registered on NICR)</label>
              <input
                type="text"
                name="fullNames"
                value={formData.fullNames}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>2. Other names you are known by</label>
              <input
                type="text"
                name="otherNames"
                value={formData.otherNames}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>3. Date of Birth (DD/MM/YYYY)</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>4. Identity Document Number</label>
              <input
                type="text"
                name="identityDocumentNumber"
                value={formData.identityDocumentNumber}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>5. Gender</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="Male"
                    checked={formData.gender === 'Male'}
                    onChange={handleChange}
                  />
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="Female"
                    checked={formData.gender === 'Female'}
                    onChange={handleChange}
                  />
                  Female
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>Nationality</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>6. Current Marital Status</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="Single"
                    checked={formData.currentMaritalStatus === 'Single'}
                    onChange={handleChange}
                  />
                  Single
                </label>
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="Married"
                    checked={formData.currentMaritalStatus === 'Married'}
                    onChange={handleChange}
                  />
                  Married
                </label>
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="In a relationship"
                    checked={formData.currentMaritalStatus === 'In a relationship'}
                    onChange={handleChange}
                  />
                  In a relationship
                </label>
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="Widowed"
                    checked={formData.currentMaritalStatus === 'Widowed'}
                    onChange={handleChange}
                  />
                  Widowed
                </label>
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="Separated"
                    checked={formData.currentMaritalStatus === 'Separated'}
                    onChange={handleChange}
                  />
                  Separated
                </label>
                <label>
                  <input
                    type="radio"
                    name="currentMaritalStatus"
                    value="Divorced"
                    checked={formData.currentMaritalStatus === 'Divorced'}
                    onChange={handleChange}
                  />
                  Divorced
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>7. Full Names of Spouse if not single</label>
              <input
                type="text"
                name="fullNamesSpouse"
                value={formData.fullNamesSpouse}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>8. Previous Marital Status (If applicable)</label>
              <div className="checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="previousMaritalStatus"
                    value="Divorced"
                    checked={formData.previousMaritalStatus.includes('Divorced')}
                    onChange={handleChange}
                  />
                  Divorced
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="previousMaritalStatus"
                    value="Widowed"
                    checked={formData.previousMaritalStatus.includes('Widowed')}
                    onChange={handleChange}
                  />
                  Widowed
                </label>
                <label>
                  <input
                    type="checkbox"
                    name="previousMaritalStatus"
                    value="Separated"
                    checked={formData.previousMaritalStatus.includes('Separated')}
                    onChange={handleChange}
                  />
                  Separated
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>9. Full Names of previous spouse (If applicable)</label>
              <input
                type="text"
                name="fullNamesPreviousSpouse"
                value={formData.fullNamesPreviousSpouse}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Attach Personal ID</label>
              <input
                type="file"
                name="personalIdFile"
                onChange={handleChange}
                accept="image/*,.pdf"
                required
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
            {formData.currentMaritalStatus !== 'Single' && (
              <div className="form-group">
                <label>Attach Spouse ID (if married or in relationship)</label>
                <input
                  type="file"
                  name="spouseIdFile"
                  onChange={handleChange}
                  accept="image/*,.pdf"
                />
                <p className="error-message">You will be contacted to provide the required attachments.</p>
              </div>
            )}
          </div>
        );
      case 2:
        return (
          <div className="form-section">
            <h3>Section 2: Contacts & Residence</h3>
            <div className="form-group">
              <label>1. Contact Numbers for Calls Main</label>
              <input
                type="tel"
                name="contactNumbersCallsMain"
                value={formData.contactNumbersCallsMain}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Other</label>
              <input
                type="tel"
                name="contactNumbersCallsOther"
                value={formData.contactNumbersCallsOther}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>2. Contact Numbers for WhatsApp/ SMS Main</label>
              <input
                type="tel"
                name="contactNumbersWhatsappMain"
                value={formData.contactNumbersWhatsappMain}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Other</label>
              <input
                type="tel"
                name="contactNumbersWhatsappOther"
                value={formData.contactNumbersWhatsappOther}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>3. Personal Email Address</label>
              <input
                type="email"
                name="personalEmailAddress"
                value={formData.personalEmailAddress}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>4. Home Location/Village name</label>
              <input
                type="text"
                name="homeLocationVillage"
                value={formData.homeLocationVillage}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>5. Street full description</label>
              <input
                type="text"
                name="streetFullDescription"
                value={formData.streetFullDescription}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>6. Name of homeowner / Chief</label>
              <input
                type="text"
                name="nameHomeownerChief"
                value={formData.nameHomeownerChief}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>7. Social Media Channel & Names (Link)</label>
              <input
                type="text"
                name="socialMediaChannelNames"
                value={formData.socialMediaChannelNames}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Attach Utility Bill</label>
              <input
                type="file"
                name="utilityBillFile"
                onChange={handleChange}
                accept="image/*,.pdf"
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
          </div>
        );
      case 3:
        return (
          <div className="form-section">
            <h3>Section 3: Next of Kin Details</h3>
            <div className="form-group">
              <label>1. Title & Full Names</label>
              <input
                type="text"
                name="nextKinTitleFullNames"
                value={formData.nextKinTitleFullNames}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>2. Relationship</label>
              <input
                type="text"
                name="nextKinRelationship"
                value={formData.nextKinRelationship}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>3. Home Location/Village name</label>
              <input
                type="text"
                name="nextKinHomeLocationVillage"
                value={formData.nextKinHomeLocationVillage}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>4. Contact Number Calls</label>
              <input
                type="tel"
                name="nextKinContactCalls"
                value={formData.nextKinContactCalls}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Text</label>
              <input
                type="tel"
                name="nextKinContactText"
                value={formData.nextKinContactText}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>5. Email Address</label>
              <input
                type="email"
                name="nextKinEmailAddress"
                value={formData.nextKinEmailAddress}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Attach Next of Kin ID</label>
              <input
                type="file"
                name="nextKinIdFile"
                onChange={handleChange}
                accept="image/*,.pdf"
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
          </div>
        );
      case 4:
        return (
          <div className="form-section">
            <h3>Section 4: Career & Employment</h3>
            <h4>1. Employment details: Current</h4>
            <div className="form-group">
              <label>Employer / Entity name</label>
              <input
                type="text"
                name="currentEmployerName"
                value={formData.currentEmployerName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Start Date - End Date</label>
              <input
                type="text"
                name="currentStartDateEndDate"
                value={formData.currentStartDateEndDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Department</label>
              <input
                type="text"
                name="currentDepartment"
                value={formData.currentDepartment}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Position</label>
              <input
                type="text"
                name="currentPosition"
                value={formData.currentPosition}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Employment Number</label>
              <input
                type="text"
                name="currentEmploymentNumber"
                value={formData.currentEmploymentNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Contact Number Main</label>
              <input
                type="tel"
                name="currentContactMain"
                value={formData.currentContactMain}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Place / location</label>
              <input
                type="text"
                name="currentPlaceLocation"
                value={formData.currentPlaceLocation}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Industry or sector</label>
              <input
                type="text"
                name="currentIndustrySector"
                value={formData.currentIndustrySector}
                onChange={handleChange}
              />
            </div>
            
            <h4>Immediate Past</h4>
            <div className="form-group">
              <label>Employer / Entity name</label>
              <input
                type="text"
                name="immediatePastEmployerName"
                value={formData.immediatePastEmployerName}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Start Date - End Date</label>
              <input
                type="text"
                name="immediatePastStartDateEndDate"
                value={formData.immediatePastStartDateEndDate}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Department</label>
              <input
                type="text"
                name="immediatePastDepartment"
                value={formData.immediatePastDepartment}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Position</label>
              <input
                type="text"
                name="immediatePastPosition"
                value={formData.immediatePastPosition}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Employment Number</label>
              <input
                type="text"
                name="immediatePastEmploymentNumber"
                value={formData.immediatePastEmploymentNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Contact Number Main</label>
              <input
                type="tel"
                name="immediatePastContactMain"
                value={formData.immediatePastContactMain}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Place / location</label>
              <input
                type="text"
                name="immediatePastPlaceLocation"
                value={formData.immediatePastPlaceLocation}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Industry or sector</label>
              <input
                type="text"
                name="immediatePastIndustrySector"
                value={formData.immediatePastIndustrySector}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Highest Qualification</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="highestQualification"
                    value="Under Diploma"
                    checked={formData.highestQualification === 'Under Diploma'}
                    onChange={handleChange}
                  />
                  Under Diploma
                </label>
                <label>
                  <input
                    type="radio"
                    name="highestQualification"
                    value="Diploma"
                    checked={formData.highestQualification === 'Diploma'}
                    onChange={handleChange}
                  />
                  Diploma
                </label>
                <label>
                  <input
                    type="radio"
                    name="highestQualification"
                    value="Degree"
                    checked={formData.highestQualification === 'Degree'}
                    onChange={handleChange}
                  />
                  Degree
                </label>
                <label>
                  <input
                    type="radio"
                    name="highestQualification"
                    value="Masters"
                    checked={formData.highestQualification === 'Masters'}
                    onChange={handleChange}
                  />
                  Masters
                </label>
                <label>
                  <input
                    type="radio"
                    name="highestQualification"
                    value="PhD"
                    checked={formData.highestQualification === 'PhD'}
                    onChange={handleChange}
                  />
                  PhD
                </label>
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div className="form-section">
            <h3>Section 5: Funeral Cover & Benefits</h3>
            <p>Finite Magazine Lifestyle Club membership includes FREE Funeral Cover (Underwritten by Liberty Life 
Lesotho) for all Members immediate families (T&amp;C apply).</p>
            
            <table className="funeral-cover-table">
              <thead>
                <tr>
                  <th>Membership Plan</th>
                  <th>Amounts</th>
                  <th>Member</th>
                  <th>Spouse</th>
                  <th>Child 14-21</th>
                  <th>Child 6-13</th>
                  <th>Child 1-5</th>
                  <th>Child &lt;1</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Standard</td>
                  <td></td>
                  <td>M20,000</td>
                  <td>M20,000</td>
                  <td>M10,000</td>
                  <td>M5,000</td>
                  <td>M2,500</td>
                  <td>M1,500</td>
                </tr>
                <tr>
                  <td>Silver</td>
                  <td></td>
                  <td>M25,000</td>
                  <td>M25,000</td>
                  <td>M15,000</td>
                  <td>M7,500</td>
                  <td>M3,500</td>
                  <td>M2,000</td>
                </tr>
                <tr>
                  <td>Gold</td>
                  <td></td>
                  <td>M30,000</td>
                  <td>M30,000</td>
                  <td>M20,000</td>
                  <td>M10,000</td>
                  <td>M5,000</td>
                  <td>M2,500</td>
                </tr>
                <tr>
                  <td>Platinum</td>
                  <td></td>
                  <td>M40,000</td>
                  <td>M40,000</td>
                  <td>M25,000</td>
                  <td>M12,500</td>
                  <td>M6,000</td>
                  <td>M3,000</td>
                </tr>
              </tbody>
            </table>

            <h4>Children (6)</h4>
            <table>
              <thead>
                <tr>
                  <th>Names as written on NICR</th>
                  <th>Gender, Date of Birth (DD/MM/YYYY)</th>
                  <th>Issue Card (Yes/No)</th>
                </tr>
              </thead>
              <tbody>
                {formData.children.map((child, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={child.name || ''}
                        onChange={(e) => handleArrayChange('children', index, 'name', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="M"
                            checked={child.gender === 'M'}
                            onChange={(e) => handleArrayChange('children', index, 'gender', e.target.value)}
                          />
                          M
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="F"
                            checked={child.gender === 'F'}
                            onChange={(e) => handleArrayChange('children', index, 'gender', e.target.value)}
                          />
                          F
                        </label>
                      </div>
                      <input
                        type="date"
                        value={child.dob || ''}
                        onChange={(e) => handleArrayChange('children', index, 'dob', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="Yes"
                            checked={child.issueCard === 'Yes'}
                            onChange={(e) => handleArrayChange('children', index, 'issueCard', e.target.value)}
                          />
                          Yes
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="No"
                            checked={child.issueCard === 'No'}
                            onChange={(e) => handleArrayChange('children', index, 'issueCard', e.target.value)}
                          />
                          No
                        </label>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="form-group">
              <label>Upload Birth Certificates for Children</label>
              <input
                type="file"
                name="birthCertificates"
                onChange={handleChange}
                accept="image/*,.pdf"
                multiple
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>

            <h4>2. Would you like to add your parents, in-laws or extended family to your Funeral Cover?</h4>
            <div className="checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="addParentsInLawsExtended"
                  value="Parents"
                  checked={formData.addParentsInLawsExtended.includes('Parents')}
                  onChange={handleChange}
                />
                Parents
              </label>
              <label>
                <input
                  type="checkbox"
                  name="addParentsInLawsExtended"
                  value="In-laws"
                  checked={formData.addParentsInLawsExtended.includes('In-laws')}
                  onChange={handleChange}
                />
                In-laws
              </label>
              <label>
                <input
                  type="checkbox"
                  name="addParentsInLawsExtended"
                  value="Extended family"
                  checked={formData.addParentsInLawsExtended.includes('Extended family')}
                  onChange={handleChange}
                />
                Extended family
              </label>
            </div>

            <h4>Parents / In-laws (2)</h4>
            <table>
              <thead>
                <tr>
                  <th>Names as written on NICR</th>
                  <th>Gender, Date of Birth (DD/MM/YYYY)</th>
                  <th>Cover Type</th>
                </tr>
              </thead>
              <tbody>
                {['Parent 1', 'Parent 2', 'In-law 1', 'In-law 2'].map((label, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={formData.parentsInLaws[index]?.name || ''}
                        onChange={(e) => handleArrayChange('parentsInLaws', index, 'name', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="M"
                            checked={formData.parentsInLaws[index]?.gender === 'M'}
                            onChange={(e) => handleArrayChange('parentsInLaws', index, 'gender', e.target.value)}
                          />
                          M
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="F"
                            checked={formData.parentsInLaws[index]?.gender === 'F'}
                            onChange={(e) => handleArrayChange('parentsInLaws', index, 'gender', e.target.value)}
                          />
                          F
                        </label>
                      </div>
                      <input
                        type="date"
                        value={formData.parentsInLaws[index]?.dob || ''}
                        onChange={(e) => handleArrayChange('parentsInLaws', index, 'dob', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="55"
                            checked={formData.parentsInLaws[index]?.coverType === '55'}
                            onChange={(e) => handleArrayChange('parentsInLaws', index, 'coverType', e.target.value)}
                          />
                          55
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="90"
                            checked={formData.parentsInLaws[index]?.coverType === '90'}
                            onChange={(e) => handleArrayChange('parentsInLaws', index, 'coverType', e.target.value)}
                          />
                          90
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="110"
                            checked={formData.parentsInLaws[index]?.coverType === '110'}
                            onChange={(e) => handleArrayChange('parentsInLaws', index, 'coverType', e.target.value)}
                          />
                          110
                        </label>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="form-group">
              <label>Upload IDs for Parents / In-laws</label>
              <input
                type="file"
                name="parentsIds"
                onChange={handleChange}
                accept="image/*,.pdf"
                multiple
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>

            <h4>Extended Family (6)</h4>
            <table>
              <thead>
                <tr>
                  <th>Names as written on NICR</th>
                  <th>Gender, Date of Birth (DD/MM/YYYY)</th>
                  <th>Cover Type</th>
                </tr>
              </thead>
              <tbody>
                {['A', 'B', 'C', 'D', 'E', 'F'].map((letter, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={formData.extendedFamily[index]?.name || ''}
                        onChange={(e) => handleArrayChange('extendedFamily', index, 'name', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="M"
                            checked={formData.extendedFamily[index]?.gender === 'M'}
                            onChange={(e) => handleArrayChange('extendedFamily', index, 'gender', e.target.value)}
                          />
                          M
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="F"
                            checked={formData.extendedFamily[index]?.gender === 'F'}
                            onChange={(e) => handleArrayChange('extendedFamily', index, 'gender', e.target.value)}
                          />
                          F
                        </label>
                      </div>
                      <input
                        type="date"
                        value={formData.extendedFamily[index]?.dob || ''}
                        onChange={(e) => handleArrayChange('extendedFamily', index, 'dob', e.target.value)}
                      />
                    </td>
                    <td>
                      <div className="radio-group">
                        <label>
                          <input
                            type="radio"
                            value="55"
                            checked={formData.extendedFamily[index]?.coverType === '55'}
                            onChange={(e) => handleArrayChange('extendedFamily', index, 'coverType', e.target.value)}
                          />
                          55
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="90"
                            checked={formData.extendedFamily[index]?.coverType === '90'}
                            onChange={(e) => handleArrayChange('extendedFamily', index, 'coverType', e.target.value)}
                          />
                          90
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="110"
                            checked={formData.extendedFamily[index]?.coverType === '110'}
                            onChange={(e) => handleArrayChange('extendedFamily', index, 'coverType', e.target.value)}
                          />
                          110
                        </label>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="form-group">
              <label>Upload IDs for Extended Family</label>
              <input
                type="file"
                name="extendedIds"
                onChange={handleChange}
                accept="image/*,.pdf"
                multiple
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
          </div>
        );
      case 6:
        return (
          <div className="form-section">
            <h3>Section 6: Beneficiary Details</h3>
            <div className="form-group">
              <label>1. Title & Full Names</label>
              <input
                type="text"
                name="beneficiaryTitleFullNames"
                value={formData.beneficiaryTitleFullNames}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>2. Identity Number</label>
              <input
                type="text"
                name="beneficiaryIdNumber"
                value={formData.beneficiaryIdNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>3. Nationality</label>
              <input
                type="text"
                name="beneficiaryNationality"
                value={formData.beneficiaryNationality}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>4. Relationship</label>
              <input
                type="text"
                name="beneficiaryRelationship"
                value={formData.beneficiaryRelationship}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>5. Home Location/Village name</label>
              <input
                type="text"
                name="beneficiaryHomeLocationVillage"
                value={formData.beneficiaryHomeLocationVillage}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>6. Contact Number Calls</label>
              <input
                type="tel"
                name="beneficiaryContactCalls"
                value={formData.beneficiaryContactCalls}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Text</label>
              <input
                type="tel"
                name="beneficiaryContactText"
                value={formData.beneficiaryContactText}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>7. Email Address</label>
              <input
                type="email"
                name="beneficiaryEmailAddress"
                value={formData.beneficiaryEmailAddress}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Attach Beneficiary ID</label>
              <input
                type="file"
                name="beneficiaryIdFile"
                onChange={handleChange}
                accept="image/*,.pdf"
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
          </div>
        );
      case 7:
        return (
          <div className="form-section">
            <h3>Membership Fee & Payment Details</h3>
            <div className="form-group">
              <label>Main Subscription Fee Quantity</label>
              <input
                type="number"
                name="mainSubscriptionFeeQty"
                value={formData.mainSubscriptionFeeQty}
                onChange={handleChange}
                min="1"
              />
            </div>
            <div className="form-group">
              <label>Membership Card Quantity</label>
              <input
                type="number"
                name="membershipCardQty"
                value={formData.membershipCardQty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Additional Membership Quantity</label>
              <input
                type="number"
                name="additionalMembershipQty"
                value={formData.additionalMembershipQty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Main & Spouse Quantity</label>
              <input
                type="number"
                name="funeralMainSpouseQty"
                value={formData.funeralMainSpouseQty}
                onChange={handleChange}
                min="1"
              />
            </div>
            <div className="form-group">
              <label>Funeral Children Quantity</label>
              <input
                type="number"
                name="funeralChildrenQty"
                value={formData.funeralChildrenQty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Parent 1 Quantity</label>
              <input
                type="number"
                name="funeralParent1Qty"
                value={formData.funeralParent1Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Parent 2 Quantity</label>
              <input
                type="number"
                name="funeralParent2Qty"
                value={formData.funeralParent2Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral In-law 1 Quantity</label>
              <input
                type="number"
                name="funeralInLaw1Qty"
                value={formData.funeralInLaw1Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral In-law 2 Quantity</label>
              <input
                type="number"
                name="funeralInLaw2Qty"
                value={formData.funeralInLaw2Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Extended 55 Quantity</label>
              <input
                type="number"
                name="funeralExtended55Qty"
                value={formData.funeralExtended55Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Extended 90 Quantity</label>
              <input
                type="number"
                name="funeralExtended90Qty"
                value={formData.funeralExtended90Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Funeral Extended 110 Quantity</label>
              <input
                type="number"
                name="funeralExtended110Qty"
                value={formData.funeralExtended110Qty}
                onChange={handleChange}
                min="0"
              />
            </div>
            <div className="form-group">
              <label>Subscription Frequency</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="subscriptionFrequency"
                    value="monthly"
                    checked={formData.subscriptionFrequency === 'monthly'}
                    onChange={handleChange}
                  />
                  Monthly
                </label>
                <label>
                  <input
                    type="radio"
                    name="subscriptionFrequency"
                    value="annual"
                    checked={formData.subscriptionFrequency === 'annual'}
                    onChange={handleChange}
                  />
                  Annual
                </label>
              </div>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="agreeToPay"
                  checked={formData.agreeToPay}
                  onChange={handleChange}
                />
                I agree to pay the total amount due
              </label>
            </div>
            <div className="form-group">
              <label>Payment Method</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="mpesa"
                    checked={formData.paymentMethod === 'mpesa'}
                    onChange={handleChange}
                  />
                  Mpesa
                </label>
                <label>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="ecocash"
                    checked={formData.paymentMethod === 'ecocash'}
                    onChange={handleChange}
                  />
                  Ecocash
                </label>
                <label>
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="bank"
                    checked={formData.paymentMethod === 'bank'}
                    onChange={handleChange}
                  />
                  Bank Transfer
                </label>
              </div>
            </div>
            {formData.paymentMethod === 'mpesa' && (
              <div className="form-group">
                <label>Mpesa Number</label>
                <input
                  type="tel"
                  name="mpesaNumber"
                  value={formData.mpesaNumber}
                  onChange={handleChange}
                />
              </div>
            )}
            {formData.paymentMethod === 'ecocash' && (
              <div className="form-group">
                <label>Ecocash Number</label>
                <input
                  type="tel"
                  name="ecocashNumber"
                  value={formData.ecocashNumber}
                  onChange={handleChange}
                />
              </div>
            )}
            {formData.paymentMethod === 'bank' && (
              <>
                <div className="form-group">
                  <label>Account Holder</label>
                  <input
                    type="text"
                    name="accountHolder"
                    value={formData.accountHolder}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    name="bankName"
                    value={formData.bankName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Account Number</label>
                  <input
                    type="text"
                    name="accountNo"
                    value={formData.accountNo}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Branch Code</label>
                  <input
                    type="text"
                    name="branchCode"
                    value={formData.branchCode}
                    onChange={handleChange}
                  />
                </div>
              </>
            )}
            <div className="form-group">
              <label>Upload Payment Proof</label>
              <input
                type="file"
                name="paymentProof"
                onChange={handleChange}
                accept="image/*,.pdf"
              />
              <p className="error-message">You will be contacted to provide the required attachments.</p>
            </div>
          </div>
        );
      case 8:
        return (
          <div className="form-section">
            <h3>Section 7: Member Application Declaration</h3>
            <p>By submitting this application, the undersigned acknowledges and agrees to the following terms regarding the Finite Magazine Lifestyle Club (FMLC) Membership Program:</p>
            <ol>
              <li>All applications are subject to review by the FMLC Advisory Team.</li>
              <li>Final approval is based on alignment with FMLC values, business ethics, and market relevance.</li>
              <li>Upon acceptance, the applicant will receive an official contract outlining roles, responsibilities, and benefit structures.</li>
              <li>Signing the contract is mandatory to confirm Member status and activate privileges.</li>
              <li>Approved Members will receive a personalized FMLC Card 7-14 working days after.</li>
              <li>This card serves as formal identification and access credential within the FMLC ecosystem.</li>
              <li>The Membership Card grants access to exclusive benefits, partner store privileges, and FMLC-hosted events.</li>
              <li>Members must present their card during business interactions at affiliated locations and activations.</li>
              <li>Business Partner stores reserve the right to verify card authenticity and identity prior to benefit redemption.</li>
              <li>Misuse or unauthorized presentation of the card may result in suspension or termination of Membership.</li>
              <li>The Club may offer personalized assistance, event support, or logistics coordination through its official Club Concierge Team. While some services may be included in Member privileges, the activation of Club Concierge services may incur additional costs.</li>
            </ol>
            <h4>General Terms & Conditions</h4>
            <ol>
              <li>All Members must uphold professional integrity and align their offerings with FMLC’s core themes.</li>
              <li>Approval of applications takes 5–7 business days.</li>
              <li>Membership does not guarantee exclusivity unless specified through a separate agreement.</li>
              <li>Monthly administration fees are non-refundable once processed.</li>
              <li>Events co-hosted with FMLC must reflect shared values and member benefit.</li>
              <li>FMLC reserves the right to suspend membership for non-compliance or reputational harm.</li>
              <li>Members must communicate any changes in personal and work status promptly.</li>
              <li>Members may be featured in selected editorial or visual campaign materials unless otherwise indicated.</li>
            </ol>

            <h4>1. MEMBER (APPLICANT)</h4>
            <div className="form-group">
              <label>Title & Full Names</label>
              <input
                type="text"
                name="memberTitleFullNames"
                value={formData.memberTitleFullNames}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                name="memberDate"
                value={formData.memberDate}
                onChange={handleChange}
                required
              />
            </div>

            <h4>2. FMLC REPRESENTATIVE</h4>
            <div className="form-group">
              <label>Title & Full Names</label>
              <input
                type="text"
                name="fmlcRepTitleFullNames"
                value={formData.fmlcRepTitleFullNames}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Position</label>
              <input
                type="text"
                name="fmlcRepPosition"
                value={formData.fmlcRepPosition}
                onChange={handleChange}
                required
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                name="fmlcRepDate"
                value={formData.fmlcRepDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Remarks</label>
              <input
                type="text"
                name="fmlcRepRemarks"
                value={formData.fmlcRepRemarks}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Signature</label>
              <input
                type="text"
                name="fmlcRepSignature"
                value={formData.fmlcRepSignature}
                onChange={handleChange}
                required
              />
            </div>

            <h4>3. FMLC APPROVER</h4>
            <div className="form-group">
              <label>Title & Full Names</label>
              <input
                type="text"
                name="fmlcApprTitleFullNames"
                value={formData.fmlcApprTitleFullNames}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Position</label>
              <input
                type="text"
                name="fmlcApprPosition"
                value={formData.fmlcApprPosition}
                onChange={handleChange}
                required
                readOnly
              />
            </div>
            <div className="form-group">
              <label>Date</label>
              <input
                type="date"
                name="fmlcApprDate"
                value={formData.fmlcApprDate}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Remarks</label>
              <input
                type="text"
                name="fmlcApprRemarks"
                value={formData.fmlcApprRemarks}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Signature</label>
              <input
                type="text"
                name="fmlcApprSignature"
                value={formData.fmlcApprSignature}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        );
      case 9:
        return (
          <div className="form-section">
            <h3>Query</h3>
            <div className="form-group">
              <label>Coordinator Query</label>
              <textarea
                name="coordinatorQuery"
                value={formData.coordinatorQuery}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Other Comments</label>
              <textarea
                name="otherComments"
                value={formData.otherComments}
                onChange={handleChange}
              />
            </div>
            <button type="button" onClick={showQueryMessage}>
              Submit Query
            </button>
            {showQuery && <p>Your query has been submitted. A coordinator will contact you soon.</p>}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <form onSubmit={handleSubmit} className="member-form">
      {renderStep()}
      <div className="navigation-buttons">
        {currentStep > 1 && (
          <button type="button" onClick={prevStep} disabled={saving || loading}>
            Previous
          </button>
        )}
        {currentStep < 9 ? (
          <button type="button" onClick={nextStep} disabled={saving || loading}>
            Next
          </button>
        ) : (
          <button type="submit" disabled={saving || loading}>
            Submit
          </button>
        )}
      </div>
      {(saving || loading) && <p>Saving...</p>}
    </form>
  );
};

export default MemberForm;